import React from 'react';
import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';
import { Button } from '@mui/material';
import Paragraph from 'components/atoms/Paragraph/Paragraph';
import Heading from 'components/atoms/Heading/Heading';
import { theme } from 'theme/MainTheme';
import { useTranslation } from 'react-i18next';

const StyledSection = styled.section`
  width: 100vw;
  height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

const Unauthorized = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const goBack = () => navigate('/login');

  return (
    <StyledSection>
      <Heading>Brak dostępu</Heading>
      <Paragraph>Nie masz uprawnień do przeglądania tej strony.</Paragraph>
      <Button
        type="button"
        variant="contained"
        sx={{ backgroundColor: theme.primary, width: '150px' }}
        onClick={goBack}
      >
        {t('back')}
      </Button>
    </StyledSection>
  );
};

export default Unauthorized;
